/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Image laden und anzeigen 
 * 
 * Beim Laden wird zunächst geprüft, ob das Image bereits im 'ImageBuffer' zur 
 * Verfügung steht, falls ja, so werden die Bilddaten aus dem 'ImageBuffer' angezeigt.
 * Falls das Image noch nicht im ImageBuffer vorliegt, so wird das Image aus dem 
 * 'LocalStorage' geladen und angezeigt.
 * 
 * Der 'ImageBuffer' wurde entwickelt, um Images noch schneller anzeigen zu können.
 * Diese Vorgehensweise hat einen gravierenden Performance-Vorteil, da es schneller 
 * ist ein Image aus dem REDUX-Store zu laden, als aus dem lokalen Speicher.  
 * Grundsätzlich würde es reichen, wenn die Images immer direkt vom 'LocalStorage'
 * geladen werden. Dadurch, dass die Images jedoch aus dem vorgeschalteten 'ImageBuffer' 
 * geladen werden können, kann ein leichtes Flackern der Images bei der Anzeige im Dialog 
 * verhindert werden. Die gesamte Anwendung wirkt dadurch viel flüssiger, gerade dann wenn 
 * mehrere Images auf einer Seite dargestellt werden wie beispielsweise in Produktübersicht 
 * oder in der Produktsuche.
 * 
 * Der 'imageBuffer' wird im PortfoliosController.js gefüllt.
 * 
 */
import React, { useEffect, useRef, useState } from "react";
import store from '../../store'
import * as utils from "../../basics/utils";
import * as cordova from "../../basics/cordova";

export const ImageLoader = ({ path, name, height, cover }) => {
    const { currentContainer } = store.getState().app;
    const ref = useRef(null);

    const [image, setImage] = useState('');

    // ==========================================================================
    //
    // LIFECYCLE - SECTION
    //
    // ==========================================================================

    useEffect(() => {
        const debug = false;

        if (ref.current) {
            debug && console.log('currentContainer:', currentContainer)
            debug && console.log('path:', path)
            debug && console.log('name:', name)

            const imagename = name.endsWith('pdf') ? name.replace('pdf', 'png') : name;
            debug && console.log('imagename:', imagename)

            const data = cordova.getImageFromBuffer(path, imagename);
            if (data !== null) {
                debug && console.log(`ImageLoader load from ImageBuffer [${path}/${imagename}]`)
                setImage(data);
            } else {
                debug && console.log(`ImageLoader load from LocalStorage [${path}/${imagename}]`)
                cordova.readLocalFile(currentContainer, 'image', path, imagename).then((data) => {
                    setImage(data);
                }).catch((error) => {
                    console.log(`WARNING: ImageLoader [${path}/${imagename}] not found!`, error);
                });
            }
        }
    }, [ref, currentContainer, path, name]);

    // ==========================================================================
    //
    // MAIN RENDER
    //
    // ==========================================================================

    const style = utils.getStyleBackgroundImage(image, height, cover);
    //console.log('image:', image)

    return (
        <div id={'image'} ref={ref} className="flex flex-col justify-center w-full text-center text-gray-900 " style={style}></div>
    );
};

